import { useEffect, useState } from 'react';
import { useDatabase } from './useDatabase';

export interface ResourceDetails {
  id: string;
  name: string;
  description: string | undefined;
  managedByTeamId: string | undefined;
  concurrencyLimit: number | undefined;
  cooldownDays: number | undefined;
}

export function useResource(resourceId: string | undefined) {
  const { database, loading: databaseLoading } = useDatabase();
  const [resource, setResource] = useState<ResourceDetails | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!database || !resourceId) {
      if (!database) setLoading(false);
      return;
    }

    try {
      const resources = database.resources();
      const obj = resources[resourceId];

      if (!obj) {
        setError(`Resource with ID ${resourceId} not found`);
        setResource(null);
      } else {
        setResource({
          id: resourceId,
          name: obj.name(),
          description: obj.description() ?? undefined,
          managedByTeamId: obj.managed_by_team_id() ?? undefined,
          concurrencyLimit: obj.concurrency_limit() ?? undefined,
          cooldownDays: obj.cooldown_days() ?? undefined,
        });
        setError(null);
      }
    } catch (err) {
      console.error('Error fetching resource:', err);
      setError(`Error fetching resource: ${err}`);
      setResource(null);
    } finally {
      setLoading(false);
    }
  }, [database, resourceId]);

  return { resource, loading: loading || databaseLoading, error };
}
